// extracted by mini-css-extract-plugin
export default {"productGallery":"mM-z","inQuickShop":"nM-z"};